import L from 'leaflet';
import {useEffect, useState} from 'react';
import {
  MapContainer,
  Marker,
  TileLayer,
  useMap,
  useMapEvents,
} from 'react-leaflet';

export const iconPerson = new L.Icon({
  iconUrl: require('../../assets/image/icon_location.png'),
  iconRetinaUrl: require('../../assets/image/icon_location.png'),
  iconSize: new L.Point(60, 75),
  className: '',
});

interface ILocation {
  lat: number;
  lng: number;
}

interface IAddAdvertisementMapProps {
  center?: ILocation;
  selectLocation: (e: L.LatLng) => void;
}

function LocationMarker({selectLocation, center}: IAddAdvertisementMapProps) {
  const [position, setPosition] = useState<ILocation | null>(null);

  // Initialize position when center changes
  useEffect(() => {
    if (center?.lat && center?.lng) {
      setPosition(center);
    }
  }, [center]);

  const map = useMapEvents({
    click: (e: L.LeafletMouseEvent) => {
      setPosition(e.latlng);
      selectLocation(e.latlng);
      map.flyTo(e.latlng, map.getZoom());
    },
  });

  return position ? <Marker position={position} icon={iconPerson} /> : null;
}

function MapResizeHandler() {
  const map = useMap();

  useEffect(() => {
    const container = map.getContainer();

    const invalidate = () => {
      map.invalidateSize({
        pan: false,
        animate: false,
      });
    };

    // Initial correction after the browser has finished layout.
    const timeout = window.setTimeout(invalidate, 0);

    // Handles responsive layout changes.
    const resizeObserver = new ResizeObserver(() => {
      invalidate();
    });

    resizeObserver.observe(container);

    window.addEventListener('resize', invalidate);

    return () => {
      window.clearTimeout(timeout);
      resizeObserver.disconnect();
      window.removeEventListener('resize', invalidate);
    };
  }, [map]);

  return null;
}

const AdvertismentMap = ({
  center,
  selectLocation,
}: IAddAdvertisementMapProps) => {
  // Default to a valid fallback location if center is invalid
  const safeCenter =
    center?.lat && center?.lng ? center : {lat: 35.6895, lng: 51.389}; // Tehran coordinates as fallback

  return (
    <div className="overflow-hidden w-full rounded">
      <MapContainer
        attributionControl={false}
        zoomControl={true}
        doubleClickZoom={false}
        scrollWheelZoom={true}
        zoom={16}
        center={safeCenter}
        className="w-full"
        style={{
          height: '192px',
          borderRadius: '5px',
        }}
      >
        <TileLayer url="http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}" />

        <MapResizeHandler />

        <LocationMarker center={safeCenter} selectLocation={selectLocation} />
      </MapContainer>
    </div>
  );
};

export default AdvertismentMap;
